import { MetricLocalization } from "@/types"
import { useMemo } from "react"
import { useGetMetricLocalizationsQuery } from "@/store/metricLocalization/api";

export const useMetricLocalizations = () => {
    const { data: responseData, isLoading } = useGetMetricLocalizationsQuery();
    
    const metricLocalizations: MetricLocalization[] | null = useMemo(() => {
        if(!responseData || isLoading) {
            return [];
        }
        return responseData;
    }, [responseData]) 

    const getMetricLocalizationById = (metricPointPlatformUId: string): MetricLocalization | undefined => {
        return metricLocalizations.find(x => x.metricPointPlatforms.find(y => y.uId === metricPointPlatformUId));
    }

    return {
        isLoading,
        metricLocalizations,
        getMetricLocalizationById
    }
}